import React from 'react';

const BaseDiv = React.memo(({ children, ...rest }) => {
  return <div {...rest}>{children}</div>;
});

export default BaseDiv;
